import { useMutation } from '@apollo/client';
import { UpdateProjectDocument } from './mutation.gql';
export const useUpdateProject = () => {
    const [mutate, state] = useMutation(UpdateProjectDocument);
    const updateProject = (id, input) => mutate({ variables: { id, input } });
    return [updateProject, state];
};
